import React, { createContext, useContext, useState } from "react";
import { useCart } from "./CartContext"; 
import { toast } from "react-toastify";

const PackageCartContext = createContext();

export const PackageCartProvider = ({ children }) => {
  const { cart, addToCart, removeFromCart, setCart } = useCart();

  const [pendingItem, setPendingItem] = useState(null);
  const [showReplacePopup, setShowReplacePopup] = useState(false);
  const [loading, setLoading] = useState(false);

  // ================= ADD PACKAGE =================
const handleAddPackageItem = async (pkg, labId) => {
  const currentLabId = Number(labId);

  const cartLabIds = cart
    .map((item) => Number(item.labId || item.storeId))
    .filter((id) => !isNaN(id));

  const hasDifferentLab = cartLabIds.some((id) => id !== currentLabId);

  const newItem = {
    productId: pkg.productId || pkg.packageId,
    testName: pkg.testName || pkg.packageName,
    testPrice: pkg.testPrice || pkg.packagePrice,
    description: pkg.description || "",
    tests: pkg.tests || [],
    labId: currentLabId,
    categoryId: 3,
    quantity: 1,
  };

  const alreadyExists = cart.some(
    (item) =>
      Number(item.productId) === Number(newItem.productId) &&
      item.categoryId === 3
  );

  if (alreadyExists) {
    toast.info(`${newItem.testName} already in cart 🛒`);
    return;
  }

  if (hasDifferentLab) {
    setPendingItem(newItem);
    setShowReplacePopup(true);
  } else {
    const success = await addToCart(newItem);

    // ✅ sirf success pe toast
    if (success) {
      toast.success(`${newItem.testName} added to cart ✅`);
    }
  }
};

  // ================= REMOVE PACKAGE =================
  const handleRemovePackage = (pkg) => {
    if (!pkg || (!pkg.packageId && !pkg.productId)) {
      console.error("❌ Invalid package object:", pkg);
      toast.error("Cannot remove package: invalid data");
      return;
    }

    const payload = {
      productId: pkg.productId || pkg.packageId,
      categoryId: 3,
      price: pkg.testPrice || pkg.packagePrice || 0,
      storeId: pkg.labId,
      ItemName: pkg.testName || pkg.packageName || "Package",
      totalQuantity: -1,
      discount: 0,
      coupon: "",
    };

    console.log("🟢 Package remove payload:", payload);

    removeFromCart(payload);
   toast.success(`${pkg.packageName || pkg.testName} removed ❌`);
  };

  // ================= CONFIRM / CANCEL REPLACE =================
  const confirmReplaceCart = async () => {
    if (!pendingItem) return;
    setLoading(true);

    try {
      // 🔹 full cart delete
      const cartId = localStorage.getItem("cartId");
      if (cartId) {
        await removeFromCart(cartId); // full cart remove
      }

      // 🔹 pending item add
      addToCart(pendingItem);
      toast.success(`${pendingItem.testName} added to cart ✅`);
    } catch (err) {
      console.error("Error replacing cart:", err);
      toast.error("Failed to replace cart");
    }

    setLoading(false);
    setPendingItem(null);
    setShowReplacePopup(false);
  };

  const cancelReplaceCart = () => {
    setPendingItem(null);
    setShowReplacePopup(false);
  };

  return (
    <PackageCartContext.Provider
      value={{
        handleAddPackageItem,
        handleRemovePackage,
        pendingItem,
        showReplacePopup,
        confirmReplaceCart,
        cancelReplaceCart,
        loading,
      }}
    >
      {children}
    </PackageCartContext.Provider>
  );
};

export const usePackageCart = () => useContext(PackageCartContext);